import React, { useState } from "react";
import { type Feedback, resolveErrorsAsync } from "../utils/form-util";
import type { Validation } from "./ValidationContext";

export function useValidation(includeLabel = true): Validation {
  const [validationCounter, setValidationCounter] = useState<number>(0);
  const [validationFeedback, setValidationFeedback] = useState<Feedback[]>([]);
  const validated = validationCounter > 0;
  const suppressFieldErrors = validationFeedback.length > 0;
  const validateForm = (form: HTMLFormElement) => {
    const validateResult = form.checkValidity();
    resolveErrorsAsync(form, setValidationFeedback, includeLabel);
    setValidationCounter((c) => c + 1);
    return validateResult;
  };
  const validate = (event: React.SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    return validateForm(form);
  };

  return {
    validated,
    validationCounter,
    validationFeedback,
    suppressFieldErrors,
    validate,
    validateForm,
  };
}
